module.exports = __webpack_public_path__ + "static/media/RESEARCH_m_mr.a7c86895.jpg";